
import React from "react";
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

export type ImageDisplayProps = {
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    title: string;
    message: string;
    images: Array<string>;
} & DefaultComponentProps;

export const ImageDisplayDialog = ({ onConfirm, onClose, open, title, message, images }: ImageDisplayProps) => {
    
    return (
        <Dialog onClose={onClose} open={open} >
            <DialogTitle>
                <FlexGrid container fullHeight fullWidth direction="row" justify='space-between' alignItems='flex-start' spacing={2}>
                    <Typography variant="h2">{title}</Typography>
                    <IconButton onClick={onClose} sx={{paddingRight: 0}}><Close /></IconButton>
                </FlexGrid>
            </DialogTitle>
            <DialogContent>
                <FlexGrid container fullHeight fullWidth direction="row" justify='space-between' alignItems='flex-start' spacing={3}>
                    {images?.map((item, index) => {
                        return (
                            <FlexGrid key={index} padding={2}>
                                <img src={item} alt={"image-"+index}/>
                            </FlexGrid>
                        )
                        
                    })}
                </FlexGrid>
            </DialogContent>
            <DialogActions>
                <FlexGrid container fullHeight fullWidth style={{ marginTop: '20px', justifyContent: "right" }}>
                    <Button onClick={onConfirm} size='normal'>
                        Aprobar
                    </Button>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}